import * as Sentry from '@sentry/vue';
import { App } from 'vue';
import { Router } from 'vue-router';

import config from '@/config';

import pkg from '../package.json';

import UnpackedError from './errors/UnpackedError';
import { useAuthStore } from './stores/auth/auth';


export default class SentryApi {
  static init(app: App, router: Router) {
    const authStore = useAuthStore();
    try {
      Sentry.init({
        app,
        enabled: config.SENTRY_ENABLED,
        dsn: config.SENTRY_DSN,
        environment: config.SENTRY_ENV,
        replaysSessionSampleRate: config.SENTRY_REPLAY_SESSIONS,
        replaysOnErrorSampleRate: config.SENTRY_ERROR_REPLAY_SESSIONS,
        beforeSend(event) {
          event.tags = {
            username: authStore.username,
            feature: config.FEATURE,
            accountId: authStore.accountId,
            role: authStore.role,
            userId: authStore.userId,
          };

          return event;

        },
        release: `${config.SENTRY_PROJECT}@${pkg.version}`,
        integrations: [
          Sentry.browserTracingIntegration({ router }),
          Sentry.replayIntegration(),
        ],
        attachStacktrace: true,
        autoSessionTracking: true,
        maxBreadcrumbs: config.SENTRY_MAX_BREADCRUMBS,
        tracesSampleRate: config.SENTRY_TRACES_SAMPLE_RATE,
      });
    } catch (e: unknown) {
      console.error(`Can not initiate Sentry due to: ${e}`);
    }
  }

  static captureException(err: unknown) {
    const unpackedError = new UnpackedError(err);
    Sentry.captureException(unpackedError);
    console.error(unpackedError);
  }
}
